import { render, staticRenderFns } from "./TabWindow.vue?vue&type=template&id=a307accc&"
import script from "./TabWindow.vue?vue&type=script&lang=js&"
export * from "./TabWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports